<!-- <div class="pahe-header mt-4">
  <h3>{{totalComments}} Answers</h3>
</div> -->
<div class="bg-white box-shadow border-radius-10 border-all mb-4" *ngFor="let result of results; ind as index">
  <div class="comment-box p-3 d-flex bg-grey m-3">
      <div class="profile-icon profile-img-post">
          <span class="icon-char d-none"> D</span>
          <!-- <span class="img-prof" *ngIf="result.user_image; else dummyimage"><img src="{{result.user_image}}" alt="team"></span>
          <ng-template #dummyimage>
              <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
          </ng-template> -->
          <ng-container *ngIf="result.user_image">
            <span class="img-prof" ><img src="{{result.user_image}}" alt="icon"  alt="team"></span>
          </ng-container>
          <ng-container *ngIf="!result.user_image && result.name">
            <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">{{result.name.charAt(0).toUpperCase()}}</div>
          </ng-container>
          <ng-container *ngIf="!result.user_image && !result.name">
            <div class="profile-icon profile-name-icon" style="background: {{colorPick}};">G</div>
          </ng-container>
      </div>
      <div class="profile-name-type">
          <div *ngIf="result.name; else dummyName">
              <h5>{{result.name}}</h5>
          </div>
          <ng-template #dummyName>
              <div>
                  <h5>Guest User</h5>
              </div>
          </ng-template>
          <div class="comment-info" *ngIf="result.comment_description">{{result.comment_description}}</div>
          <div class="reply-upboat-list">
              <ul>
                  <li>
                      <a href="javascript:void(0)" (click)="addRemoveUpvote(result.forum_id, 'forum', result.id)" class="upvote-list-item"><img src="assets/images/upvote-colored.svg" alt="upvote"> {{result.totLikes}} Upvotes</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" class="reply-list-item" SmoothScroll [scrollTo]="postReplyId" [duration]="500" [offset]="-100" (click)="setCommentFocus()"><img src="assets/images/reply-solid.svg" alt="upvote"> reply</a>
                    <!-- <a href="javascript:void(0)" class="reply-list-item" (click)="scrollToReply('commentReply{{results[0].forum_id}}')"><img src="assets/images/reply-solid.svg" alt="upvote"> reply</a> -->
                  </li>
              </ul>
          </div>
      </div>
      <!-- <div class="dropdown post-options">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img src="assets/images/icon.svg" alt="arrow-right" class="">
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/bookmark.svg" alt="bookmark">Save Post</a>
              <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/duplicate.svg" alt="duplicate"> Duplicate</a>
              <a class="dropdown-item" href="#"><img class="mr-2" src="assets/images/flag.svg" alt="flag"> Report</a>
          </div>
      </div> -->
  </div>
</div>

<div *ngIf="showLoadMore">
  <button class="btn btn-dark" (click)="loadMoreComments()">Load More</button>
</div>

<!-- <ng-container *ngIf="results && results.length>0">

</ng-container> -->
<div id="{{postReplyId}}" >
  <app-create-comment [forumId]="discuss_id" [commentId]="parentId" [parentCommentId]="parentId" (commentSaved)="refreshComments($event)"></app-create-comment>
</div>


